import React, { useEffect, useState } from "react";
import style from "./IssuedBooks.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../controllers/ApiControllers";

const IssuedBooksHistory = () => {
  const [user, setUser] = useState({});
  const [books, setBooks] = useState([]);
  const { id } = useParams();
  const [bookId, setBookId] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchBook, setSearchBook] = useState("");

  const [summary, setSummary] = useState({
    totalIssued: 0,
    returnedOnTime: 0,
    returnedLate: 0,
    currentIssuedBooks: 0,
    overDueBooks: 0,
  });
  const navigate = useNavigate();
  console.log(books);


  function handleGoBack() {
    navigate(`/admin/users/issued_books/${id}`);
  }

  async function fetchUserDetails() {
    if (id) {
      const resp = await api.fetchUsers(null, id);
      if (resp.status === 0) {
        setUser(resp.data[0]);
      }
    }
  }

  async function fetchUserSummary() {
    if (id) {
      const resp = await api.fetchUserSummary(null, id);
      console.log(resp);

      if (resp?.status === 0 && resp?.data) {
        const s = resp.data;
        setSummary({
          totalIssued: s.totalIssued || 0,
          returnedOnTime: s.returnedOnTime || 0,
          returnedLate: s.returnedLate || 0,
          currentIssuedBooks: s.currentIssuedBooks || 0,
          overDueBooks: s.overDueBooks || 0,
        });
      }
    }
  }

  async function fetchIssuedBooks() {
    if (id) {
      console.log(searchBook, id);

      const resp = await api.fetchHistoryOfUser(id, searchBook);
      console.log(resp);

      if (resp?.status === 0) {
        setBooks(resp.data || []);
        setTotalPages(resp.totalPages || 1);
      }
    }
  }

  function handleSearchInput(e) {
    // console.log(e);

    e.preventDefault();
    setSearchBook(e?.target?.value);
    setCurrentPage(1);
  }

  useEffect(() => {
    fetchUserSummary();
    fetchUserDetails();
    fetchIssuedBooks();
  }, [id, currentPage]);

  return (
    <div className={`${style.container} h-screen`}>
      {/* HEADER */}
      <div className={style.navBtnRow}>
        <button className={style.navBtn} onClick={handleGoBack}>
          <img src="/back.png" alt="go back" />
        </button>
        <h2 className="text-4xl font-bold ">User History</h2>
      </div>

      {/* USER INFO + SUMMARY */}
     <div className="flex justify-between bg-gradient-to-t from-neutral-700 to-neutral-900 p-2 items-center">
       <div className={`${style.userDetails}  p-1`}>
          <div className={style.userField}>
            <span className={style.userHeading}>Name: </span>{" "}
            <span>{user.fullname}</span>
          </div>
          <div className={style.userField}>
            <span className={style.userHeading}>Mobile: </span>{" "}
            <span>{user.mobile}</span>
          </div>
          <div className={style.userField}>
            <span className={style.userHeading}>Address: </span>{" "}
            <span>{user.address}</span>
          </div>
          <div className={style.userField}>
            <span className={style.userHeading}>City: </span>{" "}
            <span>{user.city}</span>
          </div>
        </div>


        {/* ---------------- SUMMARY BOX ---------------- */}
        <div className="flex  justify-center items-end gap-4  ">
          {/* Current Issued Books */}
          <div className="p-4  bg-blue-50 shadow rounded-xl text-center border-l-4 border-blue-500">
            <div className="text-xl bold  font-medium text-gray-600 mb-2">
              Current Issued Books
            </div>
            <div className="text-3xl font-bold text-blue-700">
              {summary.currentIssuedBooks}
            </div>
          </div>

          {/* Overdue Books */}
          <div className="p-4  bg-yellow-50 shadow rounded-xl text-center border-l-4 border-yellow-500">
            <div className="text-xl bold  font-medium text-gray-600 mb-2">
              Overdue Books
            </div>
            <div className="text-3xl font-bold text-yellow-700">
              {summary.overDueBooks}
            </div>
          </div>

          {/* Total Issued */}
          <div className="p-4  bg-indigo-50 shadow rounded-xl text-center border-l-4 border-indigo-500">
            <div className="text-xl bold  font-medium text-gray-600 mb-2">
              Total Issued
            </div>
            <div className="text-3xl font-bold text-indigo-700">
              {summary.totalIssued}
            </div>
          </div>

          {/* Returned On Time */}
          <div className="p-4  bg-green-50 shadow rounded-xl text-center border-l-4 border-green-500">
            <div className="text-xl bold  font-medium text-gray-600 mb-2">
              Returned On Time
            </div>
            <div className="text-3xl font-bold text-green-700">
              {summary.returnedOnTime}
            </div>
          </div>

          {/* Returned Late */}
          <div className="p-4  bg-red-50 shadow rounded-xl text-center border-l-4 border-red-500">
            <div className="text-xl bold  font-medium text-gray-600 mb-2">
              Returned Late
            </div>
            <div className="text-3xl font-bold text-red-700">
              {summary.returnedLate}
            </div>
          </div>
        </div>

      </div>


      {/* SEARCH */}
      <div className="flex justify-between">
        <div className={style.row2}>
          <div className={style.searchUserField}>

            <input
              type="text"
              // name="searchUser"
              // value={setSearchBook || ""}
              placeholder="Search by Book Id"
              onChange={handleSearchInput}
              autoComplete="false"
            />
            <button className={style.searchBtn} onClick={fetchIssuedBooks}>
              Search
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <table style={{ textAlign: "center" }} className={style.booksList}>
        <thead
          style={{
            backgroundColor: "#dc143c",
            color: "#ffffff",
            fontSize: "15px",
            height: "32px",
          }}
        >
          <tr>
            <th>Sr. No.</th>
            <th>Book ID</th>
            {/* <th>Book Name</th> */}
            <th>Issued Date</th>
            <th>Return Date</th>
            <th>Number of Days</th>
          </tr>
        </thead>

        {Array.isArray(books) && books.length > 0 ? (
          <tbody >
            {books.map((book, index) => (
              <tr key={book.issue_id || index}>
                <td style={{ padding: "5px 0px", fontSize: "13px" }}>{index + 1}</td>
                <td >{book.book_no}</td>
                {/* <td>{book.bookname}</td> */}
                <td>{new Date(book.issued_date).toLocaleDateString()}</td>
                <td>
                  {book.return_date
                    ? new Date(book.return_date).toLocaleDateString()
                    : "-"}
                </td>
                <td>{book.number_of_days}</td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan="100%">No Books Returned</td>
            </tr>
          </tbody>
        )}
      </table>

      {/* PAGINATION */}
      {books.length > 0 && (
        <div className={`${style.footer}`}>
          <button
            className={
              currentPage === 1
                ? style.paginationBtn_disabled
                : style.paginationBtn
            }
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Prev
          </button>
          <span className={style.page}>
            {currentPage}/{totalPages}
          </span>
          <button
            className={
              currentPage === totalPages
                ? style.paginationBtn_disabled
                : style.paginationBtn
            }
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default IssuedBooksHistory;
